import { AuthUser, getCurrentUser } from 'aws-amplify/auth';
import { useEffect } from 'react';

import { useAuthResultHandler } from '@/hooks/use-auth-result-handler.ts';

import { loadUserProperties } from '@/services/auth-service.ts';

import { useAuthStore } from '@/stores/auth-store.ts';

export const useLoadUser = (): void => {
    const { handleAuthResult } = useAuthResultHandler();

    useEffect(() => {
        const loadUser = async (): Promise<void> => {
            let user: AuthUser | undefined;
            try {
                user = await getCurrentUser();
            } catch (error) {
                console.debug({ error });
            }

            try {
                const result = await loadUserProperties();
                await handleAuthResult(result, user);
                useAuthStore.setState({ isUserSet: true });
            } catch (error) {
                console.error('Failed to load user properties:', error);
                useAuthStore.setState({ isUserSet: true });
            }
        };
        void loadUser();
    }, [handleAuthResult]);
};
